import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

import { HistoryBaseComponent } from 'src/app/history-base/history-base.component';
import { SellerProductDataSource } from 'src/infrastructure/dataSource/SellerProductDataSource';
import { ImageCollection } from 'src/models/DTO/image/imageCollection';
import { Organisation } from 'src/models/DTO/organisation/organisation';
import { ProductCollectionItem } from 'src/models/DTO/products/productCollectionItem';
import { ImagesService } from 'src/services/request/images/images.service';
import { PartnerService } from 'src/services/request/partner/partner.service';
import { ProductsService } from 'src/services/request/products/products.service';
import { RatingsService } from 'src/services/request/ratings/ratings.service';
import { HistoryService } from 'src/services/state/history/history.service';

@Component({
  selector: 'app-sellerproducts',
  templateUrl: './sellerproducts.component.html',
  styleUrls: ['./sellerproducts.component.css']
})
export class SellerproductsComponent extends HistoryBaseComponent implements OnInit {
  private _ds?: SellerProductDataSource;
  private _partner?: Organisation;
  private _partnerUUID?: string;
  private _partnerImages: ImageCollection = { data: [] };

  constructor(
    private productsService: ProductsService,
    private activatedRoute: ActivatedRoute,
    private imagesService: ImagesService,
    private partnerService: PartnerService,
    private router: Router,
    private ratingsService: RatingsService,
    private cd: ChangeDetectorRef,
    protected locationService: Location,
    protected historyService: HistoryService
  ) {
    super(locationService, historyService);
    this._pageTitle = 'partner';
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(urlParams => {
      this._partnerUUID = urlParams.id;

      this.partnerService.getPartnerInfo(urlParams.id).subscribe(response => {
        this._partner = response;
        this.getImagesForPartner(this._partner?.data.uuid || '');
        this.changeDataSource();
      });
    });
  }

  ngAfterViewInit(): void {

  }

  get ds() {
    return this._ds;
  }

  get partnerImage() {
    return this._partnerImages.data.length
      ? this._partnerImages.data[0].original.url
      : '/assets/images/shared/default-user-icon.png';
  }

  get partner() {
    return this._partner;
  }

  get locationAddress() {
    return this._partner?.data.contact.street_name + ', ' + this._partner?.data.contact.city + ', ' + this._partner?.data.contact.post_code;
  }

  get workingTime(): string {
    const obj = this._partner?.data.opening_hours as { [key: string]: string | string[] } | undefined;

    if (!obj) {
      return '';
    }

    const dayOfWeek = new Date()
      .toLocaleString('en-us', { weekday: 'long' })
      .toLowerCase();

    const value = obj[dayOfWeek];

    return Array.isArray(value) ? value.join(', ') : (value || '');
  }

  private changeDataSource(query: string = ''): void {
    const partnerUuid = this._partner?.data.partner.uuid;

    if (!partnerUuid) {
      return;
    }

    this.productsService.getAllPortionOfProductsPerPartner(1, 1, partnerUuid, query).subscribe(response => {
      this._ds = undefined;

      setTimeout(() => {
        this._ds = new SellerProductDataSource(
          this.productsService,
          this.imagesService,
          this.ratingsService,
          response.meta.last_page,
          partnerUuid,
          query
        );

        this.cd.detectChanges();
      }, 1000);
    });
  }

  private getImagesForPartner(partnerUUID: string): void {
    this.imagesService.getImagesForProduct('ORGANISATION', partnerUUID, 'logo').subscribe(response => {
      this._partnerImages = response;
    });
  }

  onSearchTextChange(event: any): void {
    const searchText = event.value;

    if (!searchText) {
      this.changeDataSource();
    } else if (searchText.length >= 3) {
      this.changeDataSource(searchText);
    }
  }

  info(): void {
    this.router.navigate(['partner/info/' + this._partner?.data.uuid]);
  }

  public getBasePriceAmount(product: ProductCollectionItem): number | null {
    if (!product?.pricing?.length) {
      return null;
    }

    const firstPrice = product.pricing[0]?.price_per_piece;

    if (!firstPrice) {
      return null;
    }

    const parsedPrice = Number.parseFloat(firstPrice);

    return Number.isNaN(parsedPrice) ? null : parsedPrice;
  }

  openItem(productUUID: string, categoryUUID: string): void {
    this.router.navigate(['product/' + productUUID.toString() + '/' + categoryUUID]);
  }
}
